export type Testimonial = {
  quote: string;
  name: string;
  role: string;
  location: string;
  flag: string;
  img: string;
};

export const testimonials: Testimonial[] = [
  {
    quote:
      'I work nights in a guard booth and my daily activity reports used to be a mess of scribbled notes. Now I drop my notes into the incident and DAR prompts and get a clean, chronological draft that I check against my log. My supervisor noticed the difference in the first week.',
    name: 'Mark J.',
    role: 'Night Shift Security Officer',
    location: 'Phoenix, AZ · USA',
    flag: '🇺🇸',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/d96635d7-f579-458c-9d2b-613cd6a95e6d.jpg',
  },
  {
    quote:
      'Handovers at our site were always a weak spot — things got lost between shifts. The handover prompts gave my team one consistent format: completed, pending, follow-up. It is simple, but it finally keeps everyone on the same page.',
    name: 'Rachel W.',
    role: 'Security Supervisor',
    location: 'Manchester, UK',
    flag: '🇬🇧',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/785dd4bc-2395-46f7-84da-80a42dd83d39.jpg',
  },
  {
    quote:
      "I'm not a tech guy. I just fill in the brackets, paste it into ChatGPT and review what comes back. The client update templates alone save me a lot of rewriting, and I like that the prompts tell the AI not to invent anything.",
    name: 'Greg H.',
    role: 'Site Security Manager',
    location: 'Calgary, AB · Canada',
    flag: '🇨🇦',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/ddc94637-6730-4fdb-9ff5-12f5d26a79c8.jpg',
  },
];
